import { PersonPJProps, PersonProps } from 'pages/Register/utils/personProps';
import api from '../api/api-appdsv';

export const Register = {
  Post: async (data: PersonProps) =>
    await api.post(`/pessoa/fisica`, data.data),
  PostCompany: async (data: PersonPJProps) =>
    await api.post(`/pessoa/juridica`, data.data),
};
